import { Invoice, Product } from './Invoice'

export function openComprobanteWindow(factura: Invoice) {
  const unidadSigla: { [key: string]: string } = {
    unidad: "ud",
    gramo: "gr",
    kilogramo: "kg",
    litro: "lt",
    metro: "m"
  }

  const html = `
    <!DOCTYPE html>
    <html lang="es">
      <head>
        <meta charset="UTF-8" />
        <title>Comprobante</title>
        <style>
          body {
            width: 58mm;
            margin: 0;
            padding: 0;
            font-family: monospace;
            font-size: 14px; /* Tamaño de fuente ajustado para ser más grande */
            line-height: 1.2;
            color: #000;
            background-color: #fff;
            box-sizing: border-box;
          }
          .container {
            padding: 0 3mm;
          }
          .center { text-align: center; }
          .bold { font-weight: bold; }
          .divider {
            border-top: 1px dashed #000;
            margin: 6px 0;
          }
          .summary-line {
            line-height: 1.2;
            margin-bottom: 2px;
            white-space: nowrap;
            overflow: hidden;
          }
          .label {
            display: inline-block;
            width: 50%;
            font-weight: bold;
          }
          .value {
            display: inline-block;
            width: 45%;
            text-align: right;
            font-weight: bold;
          }
          .total-venta {
            font-size: 16px; /* Tamaño de fuente ajustado */
          }
          /* Estilos para los productos */
          .product-item {
            margin-bottom: 4px;
            overflow: hidden;
          }
          .product-name {
            display: block;
            word-wrap: break-word;
            font-weight: bold;
            font-size: 15px; /* Tamaño de fuente ajustado */
          }
          .product-details {
            font-size: 14px; /* Tamaño de fuente ajustado */
            overflow: hidden;
          }
          .product-details > span {
            display: inline-block;
            white-space: nowrap;
          }
          .product-value {
            display: inline-block;
            width: 40%;
            text-align: right;
          }
          .product-quantity {
            display: inline-block;
            width: 55%;
            white-space: nowrap;
          }
          .title {
            font-size: 16px; /* Tamaño de fuente ajustado */
            font-weight: bold;
            margin-bottom: 2px;
          }
          .subtitle {
            font-size: 15px; /* Tamaño de fuente ajustado */
            margin-bottom: 2px;
          }
          .descuento-line {
            font-size: 13px; /* Tamaño de fuente ajustado para el descuento */
            font-style: italic;
            text-align: right;
          }
          @page {
            size: 58mm auto;
            margin: 0;
          }
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="center bold title">${factura.organization.name}</div>
          <div class="center subtitle">${factura.organization.razonSocial}</div>
          <div class="center subtitle">NIT: ${factura.organization.NIT}</div>
          <div class="center subtitle">${factura.organization.direccion}, ${factura.organization.ciudad}</div>

          <div class="divider"></div>

          <div><strong>Sucursal:</strong> ${factura.sucursal.nombre}</div>
          <div>Dir: ${factura.sucursal.direccion}, ${factura.sucursal.ciudad}</div>
          ${factura.sucursal.telefono ? `<div>Tel: ${factura.sucursal.telefono}</div>` : ''}

          <div class="divider"></div>

          <div><strong>Factura:</strong> #${factura._id.substring(factura._id.length - 8).toUpperCase()}</div>
          <div><strong>Fecha:</strong> ${new Date(factura.fechaVenta).toLocaleDateString('es-CO')}</div>
          <div><strong>Hora:</strong> ${new Date(factura.fechaVenta).toLocaleTimeString('es-CO')}</div>

          <div class="divider"></div>
          <div class="bold center subtitle">Productos</div>
          ${factura.productos.map((p: Product) => `
            <div class="product-item">
              <span class="product-name">${p.producto.nombre}</span>
              <div class="product-details">
                <span class="product-quantity">${p.cantidad} ${unidadSigla[p.producto.unidadMedida] || p.producto.unidadMedida}</span>
                <span class="product-value">$${p.valor.toLocaleString()}</span>
              </div>
            </div>
            ${p.descuento && p.descuento > 0 ? `<div class="descuento-line"><span>Descuento: ${p.descuento}%</span></div>` : ''}
          `).join('')}

          <div class="divider"></div>
          ${
            typeof factura.descuentoPorcentaje === "number" && factura.descuentoPorcentaje > 0 
            ? (() => {
                const valorBruto = factura.productos.reduce((acc, p) => acc + p.valor, 0);
                const montoDescuento = valorBruto * (factura.descuentoPorcentaje / 100);
                return `
                  <div class="summary-line">
                    <span class="label">Subtotal:</span>
                    <span class="value">$${Math.round(valorBruto).toLocaleString()}</span>
                  </div>
                  <div class="summary-line">
                    <span class="label">Descuento (${factura.descuentoPorcentaje}%):</span>
                    <span class="value">-$${Math.round(montoDescuento).toLocaleString()}</span>
                  </div>
                  <div class="divider"></div>
                `;
              })()
            : ''
          }
          
          <div class="summary-line total-venta">
            <span class="label">TOTAL VENTA:</span>
            <span class="value">$${factura.totalVenta.toLocaleString()}</span>
          </div>
          <div class="summary-line">
            <span class="label">Recibido:</span>
            <span class="value">$${factura.dineroRecibido.toLocaleString()}</span>
          </div>
          <div class="summary-line">
            <span class="label">Cambio:</span>
            <span class="value">$${factura.cambio.toLocaleString()}</span>
          </div>
          <div class="summary-line">
            <span class="label">Método de Pago:</span>
            <span class="value">${factura.metodoPago}</span>
          </div>

          <div class="divider"></div>
          <div class="center bold" style="font-size: 14px;">¡Gracias por su compra!</div>
          <div class="center" style="font-size: 11px; margin-top: 6px;">
            Guarda este comprobante. ¡Vuelve pronto!
          </div>
        </div>

        <script>
          window.onload = function () {
            setTimeout(() => {
              window.print();
              setTimeout(() => window.close(), 500);
            }, 200);
          };
        </script>
      </body>
    </html>
  `;

  const newWindow = window.open("", "_blank");
  if (!newWindow) {
    const message = "Por favor, permite ventanas emergentes para imprimir la factura.";
    console.error(message);
    return;
  }
  newWindow.document.write(html);
  newWindow.document.close();
}
